import styled from 'styles/styled';

export const Box = styled.div`
  background-color: #15191E;
  width: 100%;
  border-radius: 10px;
`;

export const RowBottom = styled.div`
  width: 100%;
  margin-top: 8px;
  @media (max-width: 1020px) {
    display: none;
  }
`;
